import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./index.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// All pages
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import QuoteForm from "./pages/QuoteForm";

import { useDocTitle } from "./components/CustomHook";
import ScrollToTop from "./components/ScrollToTop";
import { ToastContainer } from "react-toastify";

function App() {
    useEffect(() => {
        const aos_init = () => {
            AOS.init({
                once: true,
                duration: 1000,
                easing: "ease-out-cubic",
            });
        };

        window.addEventListener("load", () => {
            aos_init();
        });
    }, []);

    useDocTitle("Vero | Accounting and Advisory");

    return (
        <>
            <Router>
                <ToastContainer position="top-center" theme="colored" pauseOnHover={false} pauseOnFocusLoss={false} />
                <ScrollToTop>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/request-quote" element={<QuoteForm />} />
                    </Routes>
                </ScrollToTop>
            </Router>
        </>
    );
}

export default App;
